/* ------------------------------------------------------------------
   BNZ Reviews — construit la carte de synthèse à partir des données
   exposées par le widget Judge.me (note, nombre d'avis, histogramme).
   Les avis eux-mêmes sont chargés en AJAX par Judge.me : on observe
   le widget et on (re)construit la carte dès que les données arrivent.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function formatAverage(n) {
    return (Math.round(n * 10) / 10).toFixed(1).replace('.', ',');
  }

  function starsMarkup(avg) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = avg - (i - 1);
      var cls = fill >= 0.9 ? 'is-full' : fill >= 0.4 ? 'is-half' : 'is-empty';
      html += '<span class="bnz-rev-star ' + cls + '" aria-hidden="true"></span>';
    }
    return html;
  }

  function buildSummary(section) {
    var widget = section.querySelector('.jdgm-rev-widg');
    var target = section.querySelector('[data-bnz-rev-summary]');
    if (!widget || !target) return;

    var count = parseInt(widget.getAttribute('data-number-of-reviews') || '0', 10);
    var avg = parseFloat(widget.getAttribute('data-average-rating') || '0');

    if (!count || count < 1) {
      section.classList.add('bnz-reviews--empty');
      target.innerHTML = '';
      return;
    }
    section.classList.remove('bnz-reviews--empty');

    // Barres de distribution depuis l'histogramme Judge.me
    var rows = widget.querySelectorAll('.jdgm-histogram__row[data-rating]');
    var bars = '';
    rows.forEach(function (row) {
      var rating = row.getAttribute('data-rating');
      if (!rating || rating === 'null') return;
      var freq = parseInt(row.getAttribute('data-frequency') || '0', 10);
      var pct = parseFloat(row.getAttribute('data-percentage'));
      if (isNaN(pct)) pct = count ? Math.round((freq / count) * 100) : 0;
      bars +=
        '<button type="button" class="bnz-rev-bar" data-rating="' + rating + '">' +
        '<span class="bnz-rev-bar__label">' + rating + '</span>' +
        '<span class="bnz-rev-bar__track"><span class="bnz-rev-bar__fill" style="width:' + pct + '%"></span></span>' +
        '<span class="bnz-rev-bar__count">' + freq + '</span>' +
        '</button>';
    });

    target.innerHTML =
      '<div class="bnz-rev-score">' +
        '<div class="bnz-rev-score__num">' + formatAverage(avg) + '<span>/5</span></div>' +
        '<div class="bnz-rev-score__stars">' + starsMarkup(avg) + '</div>' +
        '<div class="bnz-rev-score__count">Basé sur ' + count + (count > 1 ? ' avis' : ' avis') + '</div>' +
      '</div>' +
      '<div class="bnz-rev-bars">' + bars + '</div>';
    target.setAttribute('aria-hidden', 'false');

    // Clic sur une barre -> filtre Judge.me par note
    target.querySelectorAll('.bnz-rev-bar').forEach(function (bar) {
      bar.addEventListener('click', function () {
        var r = bar.getAttribute('data-rating');
        var jmStar = widget.querySelector(
          '.jdgm-histogram__row[data-rating="' + r + '"] .jdgm-histogram__star'
        );
        if (jmStar) jmStar.click();
      });
    });
  }

  function init(section) {
    if (section.dataset.bnzRevInit === '1') return;
    section.dataset.bnzRevInit = '1';

    buildSummary(section);

    // Le widget s'hydrate en AJAX : on reconstruit quand les données changent.
    var widgetWrap = section.querySelector('.bnz-reviews-widget');
    if (widgetWrap && 'MutationObserver' in window) {
      var raf;
      var observer = new MutationObserver(function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          buildSummary(section);
        });
      });
      observer.observe(widgetWrap, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'data-number-of-reviews',
          'data-average-rating',
          'data-frequency',
          'data-percentage',
        ],
      });
    }
  }

  function boot() {
    document.querySelectorAll('.bnz-reviews-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Réinit dans l'éditeur de thème
  document.addEventListener('shopify:section:load', boot);
})();
